import Formsy from 'formsy-react'
import FRC from 'formsy-react-components'
import React, {Component} from "react"

const Form = React.createClass({

  mixins: [FRC.ParentContextMixin],

  propTypes: {
    children: React.PropTypes.node
  },

  componentDidMount() {
    if(this.props.onRef)
      this.props.onRef(this)
  },
  componentWillUnmount() {
    if(this.props.onRef)
      this.props.onRef(undefined)
  },

  submit(){
    this.form.submit()
  },

  reset(){
    this.form.reset()
  },

  render() {
    return (
      <Formsy.Form
        ref={(form)=>{this.form = form}}
        className={this.getLayoutClassName()}
        {...this.props}
      >
        {this.props.children}
      </Formsy.Form>
    );
  }

});

export default Form



// WEBPACK FOOTER //
// ./src/components/form/Form.js